var path = 'scripts/views/components/transaction-review-icon.html';
var html = "<button ng-if=\"$ctrl.displayReviewIcon()\"\n      class=\"fa fa-fw review-icon button-border\"\n      ng-class=\"$ctrl.getIcon()\"\n      aria-label=\"{{ $ctrl.getTransactionReviewToolTip() | translate }}\"\n      uib-tooltip=\"{{ $ctrl.getTransactionReviewToolTip() | translate }}\"\n      tooltip-class=\"tooltip-bring-to-front transaction-review-tooltip\"\n      tooltip-append-to-body=\"true\">\n</button>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/views/components/transaction-review-icon.html
// module id = 363
// module chunks = 0